import { hostTenant } from "../../branding/generated/brand-manifest";
import { getActingPartner } from "../actingPartner";
import { isEmbedMode } from "../embedMode";

// The white-label web tenant a consumer is booking on (`?partner=snoonu` or a tenant
// domain), sent so app-backend can store it on the itinerary row and brand that
// booking's emails and My Trips PDF. Only the tenant folder id is sent, never a
// partner code.
//
// Omitted (the body stays exactly as before) on plain Zenvoya, where hostTenant is "",
// and in every partner context: an embed frame (portal or native-app ticket flow, both
// of which run in embed mode) or an acting-partner session already has its own tenant.
const SLUG = /^[a-z0-9][a-z0-9_-]{0,31}$/;

export function getBrandTenantField(): { brandTenant?: string } {
  try {
    const slug = String(hostTenant || "").trim();
    if (!slug || !SLUG.test(slug)) return {};
    if (isEmbedMode() || getActingPartner()) return {};
    return { brandTenant: slug };
  } catch {
    return {};
  }
}
